import React from 'react';
import withStyles from 'react-jss';
import { Translation } from 'react-i18next';
import classNames from 'classnames';

import { Droppable, Draggable } from 'react-beautiful-dnd';
import { getCustomItemStyle, getClassListStyle } from './dragDropUtil';

const customInputStyles = {
  textTitleColor: (props) => ({
    color: props.tenant.primary,
  }),
};

class CustomClass extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      titleEn: '',
    };
  }

  get customClass() {
    return this.props.customClass;
  }

  get displayDraggable() {
    return !!this.customClass;
  }

  // EVENTS

  handleInputOnChange = ({ target: { value } }) =>
    this.setState({ titleEn: value });

  createDraggable = () => {
    const { titleEn } = this.state;

    if (!titleEn) return;

    this.setState({ titleEn: '' });

    this.props.onCreate({
      titleEn,
      requirement_title: '',
      acadPlan: this.props.acadPlan,
      academic_area_id: 'Custom',
    });
  };

  // RENDER

  renderInput() {
    return (
      <div>
        <input
          aria-label="custom-class-input"
          placeholder={this.props.inputText}
          className="custom-class-input"
          onKeyDown={(e) => {
            if (['Enter'].includes(e.key)) this.createDraggable();
          }}
          onBlur={this.createDraggable}
          value={this.state.titleEn}
          onChange={this.handleInputOnChange}
        />
      </div>
    );
  }

  renderDraggable() {
    /* eslint-disable react/jsx-props-no-spreading */
    return (
      <Draggable
        onDragEnd={this.props.onDragEnd}
        key={this.customClass.title}
        draggableId={`${this.customClass.titleEn}_custom`}
        index={0}
      >
        {(dragProvided) => (
          <div
            className="custom-draggable"
            key={`${this.customClass.title}_custom`}
            ref={dragProvided.innerRef}
          >
            <div
              className="custom-draggable-content"
              {...dragProvided.draggableProps}
              {...dragProvided.dragHandleProps}
              style={getCustomItemStyle(
                dragProvided.draggableProps.style,
                this.props.tenant.primary
              )}
              key={`${this.customClass.titleEn}_custom`}
            >
              <div className="truncated-class-text custom">
                <p>{this.customClass.titleEn}</p>
              </div>
            </div>
          </div>
        )}
      </Draggable>
    );
    /* eslint-enable react/jsx-props-no-spreading */
  }

  /*
    1. If I click within the input, I'll be able to edit the class title
    2. If there is a value in the input and I click outside of the input or hit enter while the input is focused,
       it will become a dragable element with an X that can be clicked to delete the draggable element completely
    3. If I drag that element outside of the Custom Class section, a new blank input will appear in its place and the user will be able to repeat the process
  */
  render() {
    /* eslint-disable react/jsx-props-no-spreading */
    return (
      <Translation>
        {(t) => (
          <div className="custom-section">
            <div className="class-list-header-line-container">
              <hr className="custom-class-horizontal-line" />
              <p
                className={classNames(
                  'custom-class-title',
                  this.props.classes.textTitleColor
                )}
              >
                {t('Custom Class')}
              </p>
            </div>
            <Droppable isDropDisabled key="custom" droppableId="customClass">
              {(provided, snapshot) => (
                <div
                  id="classes-drag-drop-column-custom"
                  key="custom"
                  className="custom-droppable classes-drag-drop-column"
                  ref={provided.innerRef}
                  style={getClassListStyle(snapshot.draggingFromThisWith)}
                  {...provided.droppableProps}
                >
                  {this.displayDraggable
                    ? this.renderDraggable()
                    : this.renderInput()}
                  <div style={{ display: 'none' }}>{provided.placeholder}</div>
                </div>
              )}
            </Droppable>
          </div>
        )}
      </Translation>
    );
    /* eslint-enable react/jsx-props-no-spreading */
  }
}

export default withStyles(customInputStyles)(CustomClass);
